import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons'

import { Button } from '@domain-group/suit-theme'

import type { TagType } from '../../hooks/useTagInputField'

interface TagsListProps {
  callbacks: { handleRemoveTag: (tag: TagType) => void },
  fieldsArray: TagType[],
  hasTags: boolean,
}

const TagsList = (props: TagsListProps) => {
  const {
    callbacks: { handleRemoveTag }, fieldsArray, hasTags,
  } = props

  if (!hasTags) return null

  return (
    fieldsArray && fieldsArray.map((tag: TagType) => (
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTimes} />}
        iconPosition="right"
        key={tag.key}
        marginRight="small"
        onClick={() => handleRemoveTag(tag)}
        size="tiny"
        width="fit-content"
      >
        {tag.value}
      </Button>
    ))
  )
}

export default TagsList
